import { TopImage } from '@project/components/atoms';
import { LoadingContainer } from '@project/components/templates';
import { useGetShowcaseCategories } from '@project/queries';
import { useNavigate } from 'react-router-dom';

const CategoryBlock = ({ src, title, id }: { src: string; title: string; id: string }) => {
  const navigate = useNavigate();

  const handleBlockClick = () => {
    navigate(`/showcase-categories/${id}`);
  };

  return (
    <div
      className="flex h-full max-h-[550px] cursor-pointer flex-col gap-6 p-4 sm:p-10"
      onClick={handleBlockClick}
    >
      <div className="h-full">
        <img className="h-full w-[400px]" src={src} />
      </div>
      <div>
        <p
          className={`z-10 bg-white p-1 text-center font-semibold text-black shadow-sm shadow-gray-400`}
        >
          {title}
        </p>
      </div>
    </div>
  );
};

export const EventsShowcasePage: React.FC = () => {
  const { isLoading, data: showcaseCategories } = useGetShowcaseCategories();

  return (
    <div className="mb-32 flex flex-col">
      <TopImage />
      <div className="my-12 ml-4 md:ml-36">
        <p className="mb-2 text-3xl font-semibold tracking-wide">Gallery</p>
        <div className="w-24 rounded border-2 border-gold" />
      </div>
      <LoadingContainer isLoading={isLoading}>
        <div className="mx-auto grid lg:grid-cols-3">
          {showcaseCategories?.map((category) => (
            <CategoryBlock
              id={String(category.id)}
              key={category.id}
              src={category.featureImage}
              title={`${category.name}`}
            />
          ))}
        </div>
      </LoadingContainer>
    </div>
  );
};
